"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RideException_1 = require("../token/RideException");
var HttpErrorResponse_1 = require("./HttpErrorResponse");
/**
 * class used to create a IHttpErrorResponse object in case the code is != 200
 */
var HttpErrorHandler = /** @class */ (function () {
    function HttpErrorHandler() {
    }
    HttpErrorHandler.prototype.verify = function (exception) {
        var status = exception.status, data = exception.data;
        if (!status) {
            return new HttpErrorResponse_1.HttpErrorResponse({
                error: 'networkError',
                message: data || ''
            });
        }
        if (status == 401) {
            return new HttpErrorResponse_1.HttpErrorResponse({
                error: 'unauthorized',
            });
        }
        var rideException = this.parseTokenResponseForRideErrors(data);
        if (rideException) {
            return rideException;
        }
        if (status == 409) {
            return data;
        }
        if (status == 429) {
            return new HttpErrorResponse_1.HttpErrorResponse({
                error: 'rate_limited',
                retryAfter: data.retryAfter ? parseInt(data.retryAfter) : 10,
            });
        }
        if (status.toString().match(/5\d{2}/g)) {
            return new HttpErrorResponse_1.HttpErrorResponse({
                error: 'server_error'
            });
        }
        return null;
    };
    /**
        * parse the check token response to see if there are any ride errors
        * @param tokenResponse represents the response from check token call
        * @returns a RideException or null in case that the error code is not one from RideExceptions
        */
    HttpErrorHandler.prototype.parseTokenResponseForRideErrors = function (refreshException) {
        if (!refreshException) {
            return null;
        }
        var error = refreshException.error, jump = refreshException.jump;
        if (!error) {
            return null;
        }
        var isRideError = error.indexOf('ride_') === 0;
        if (!isRideError) {
            return null;
        }
        var jumpValue = jump ? jump : '';
        return new RideException_1.RideException(error, jumpValue);
    };
    /**
     * check if the exception status has the code equal 401
     * @param exception represents the exception caught during get profile method
     * @returns true if the status code is 401, otherwise false
     */
    HttpErrorHandler.prototype.isUnauthorizedException = function (exception) {
        var _a = exception.status, status = _a === void 0 ? 0 : _a;
        return status === 401;
    };
    return HttpErrorHandler;
}());
exports.default = new HttpErrorHandler();
